import apiConfig from "../config";
import ProfileUserType from "../../Types/ProfileUserType";
import CheckStatus from "../checkStatus";

type ServerResponse = RequestSuccessType;

interface RequestSuccessType {
	data: ProfileUserType | undefined;
}

interface RequestResponse extends RequestSuccessType {
	isErr: string | undefined;
}

const profileUser = (): Promise<RequestResponse> => {
	return apiConfig()
		.get<ServerResponse>(`/profile/lk`)
		.then(({ data }) => {
			//console.log("главный get запрос всего профиля ProfileUser", data.data);
			const response: RequestResponse = {
				isErr: undefined,
				data: data.data || undefined,
			};
			return response;
		})
		.catch((response) => {
			CheckStatus(response.response.status, true);

			return {
				isErr: response.data?.message,
				data: undefined,
			};
		});
};

export default profileUser;
